module.exports = __webpack_public_path__ + "static/media/fifth.4c1e9a28.png";